// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ZlOOy","buttons":"Footer_buttons__2DHsP"};